module.exports = __webpack_public_path__ + "assets/4257ae1fd759f8bc1931a5273e7d9e68.mp3";